import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { newCohortFromDataset } from '@/cohorts/actions';
import datasetStatus from '../helper';
import DatasetStatusButtons from '../components/DatasetStatusButtons';
import { showDatasetConditions } from '../../conditions/actions';

const DatasetStatusCell = ({
  accessRequestAllowed,
  accessRequestSupported,
  accessRequestUnsupportedReasons,
  dataset,
  cohortAllowed,
  cohortSupported,
  cohortUnsupportedReasons,
  hasConditions,
  newCohort,
  newCohortCode,
  newRequestCode,
  showConditions,
}) => (
  <Table.Cell className="aridhia-dataset-status-cell">
    <DatasetStatusButtons
      accessRequestAllowed={accessRequestAllowed}
      accessRequestSupported={accessRequestSupported}
      accessRequestUnsupportedReasons={accessRequestUnsupportedReasons}
      code={dataset.code}
      cohortAllowed={cohortAllowed}
      cohortSupported={cohortSupported}
      cohortUnsupportedReasons={cohortUnsupportedReasons}
      dictionaryCode={dataset.primary_dictionary}
      hasConditions={hasConditions}
      icon
      name={dataset.catalogue.title}
      newCohort={newCohort}
      newCohortCode={newCohortCode}
      newRequestCode={newRequestCode}
      showConditions={showConditions}
    />
  </Table.Cell>
);

const mapStateToProps = ({
  auth: { role },
  cohorts: { newCohortCode },
  requests: { newRequestCode },
}, { dataset }) => ({
  newCohortCode,
  newRequestCode,
  ...datasetStatus(role, dataset, dataset.primary_dictionary),
});

const mapDispatchToProps = {
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
  showConditions: showDatasetConditions,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetStatusCell);
